module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('svg', {
    attrs: {
      "id": "visualization-line-chart"
    }
  }), " ", _vm._h('svg', {
    attrs: {
      "id": "visualization-bar-graph"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02d63db0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chart.vue
// module id = 14
// module chunks = 1